<div class="dialog-content" fxLayout="column" fxLayoutAlign="space-around center">
    <div class="category-header" i18n>Prize Info</div>
    <div class="content" i18n>You can find info about all your Free Spins and Bonuses in the My Bonuses section. You can find it in the menu or click the button below to go there directly.</div>
    <div class="redirect-button">
        <button mat-raised-button color="primary" (click)="closeDialog()" [routerLink]="bonusQueueUrl" i18n>My Bonuses</button>
    </div>
    <app-close-dialog-button (closeEvent)="closeDialog()"></app-close-dialog-button>
</div>